export default __webpack_public_path__ + "static/media/inbox.919f3df0.svg";